



























































































































































































































































































































































































































































import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import { mapGetters } from 'vuex'
import { filter, IterateeShorthand } from 'lodash'
import { DueTask, Process, TaskLog } from '@/store/workflow/types'

import DepressionMixin from '@/views/treatment/depression/DepressionMixin'
import WelcomeToPatientLetter from './WelcomeToPatientLetter.vue'

export default mixins(DepressionMixin).extend({
  components: { WelcomeToPatientLetter },
  computed: {
    ...mapGetters('workflow', ['isDone']),
  },
  methods: {
    noActiveTask(process: Process): boolean {
      let tasks: DueTask[] = this.$store.getters['workflow/dueTasks']
      const filters: IterateeShorthand<TaskLog> = {}
      filters.process_instance_id = process.id
      tasks = filter(tasks, filters)
      return tasks.length == 0
    },
  },
})
